module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="w-title">\r\n	<p class="w-title__text">IBE</p>\r\n</div>\r\n';

}
return __p
}